import { IRigRate } from '../../interfaces/irig-rate';
import { Rig } from '../rig';
import { RigRateType } from '../rig-rate-type';

export class RigRateBase {
  RigRateId: number;
  RigId: number;
  RigRateTypeId: number;
  CommodityBasedPricing: boolean | null;
  Rate: number | null;
  EffectiveDate: Date | null;
  Comments: string | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Rig?: Rig;
  RigRateType?: RigRateType;

  constructor(item?: IRigRate) {
    if (item) {

      this.RigRateId = item.RigRateId;
      this.RigId = item.RigId;
      this.RigRateTypeId = item.RigRateTypeId;
      this.CommodityBasedPricing = item.CommodityBasedPricing;
      this.Rate = item.Rate;
      this.EffectiveDate = item.EffectiveDate ? new Date(item.EffectiveDate) : null;
      this.Comments = item.Comments;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Rig = new Rig(item.Rig);
      this.RigRateType = new RigRateType(item.RigRateType);
    }
  }
}